import React, { useEffect, useState } from "react";
import EmailLogList, {
  EMAIL_AUDIENCE_LABELS,
  EMAIL_KIND_LABELS,
  EMAIL_ORIGIN_LABELS,
  EMAIL_STATUS_LABELS,
} from "../../components/email-log-list";
import EmailPreviewModal from "../../components/email-preview-modal";

// Algemeen logboek van alle mail die het systeem via Resend heeft verstuurd:
// klantmails, partner-facturen en interne notificaties. Per dossier staat
// dezelfde lijst op de detailpagina van de aanvraag.
const AdminVerstuurdeMailsPage = () => {
  const [search, setSearch] = useState("");
  // Zoeken pas na een korte pauze in het typen, niet per toetsaanslag.
  const [debouncedSearch, setDebouncedSearch] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 300);
    return () => clearTimeout(t);
  }, [search]);
  const [audience, setAudience] = useState("");
  const [status, setStatus] = useState("");
  const [kind, setKind] = useState("");
  const [origin, setOrigin] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [openId, setOpenId] = useState(null);

  const filters = { search: debouncedSearch, audience, status, kind, origin, from, to };
  const hasFilters = Object.values(filters).some(Boolean) || !!search;

  const inputCls =
    "rounded-md border border-gray-200 px-2.5 py-1.5 text-sm text-gray-700 focus:border-emerald-500 focus:outline-none";

  return (
    <div className="page-wrapper px-6 pt-24 pb-12">
      <div className="mb-5">
        <h2 className="text-xl font-semibold tracking-tight text-gray-900">
          Verstuurde mails
        </h2>
        <p className="mt-1 text-xs text-gray-500">
          Alles wat vanuit het systeem is gemaild, inclusief de inhoud zoals de
          ontvanger die kreeg. Oudere mails zijn achteraf uit Resend
          geïmporteerd of uit onze eigen gegevens nagebouwd; dat staat op de
          regel. Mails die handmatig vanuit Gmail zijn gestuurd staan hier niet.
        </p>
      </div>

      <div className="mb-4 flex flex-wrap items-center gap-2">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Zoek op naam, e-mailadres of onderwerp…"
          className={`${inputCls} min-w-[260px] flex-1`}
        />
        <select value={audience} onChange={(e) => setAudience(e.target.value)} className={inputCls}>
          <option value="">Alle ontvangers</option>
          {Object.entries(EMAIL_AUDIENCE_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
        <select value={kind} onChange={(e) => setKind(e.target.value)} className={inputCls}>
          <option value="">Alle soorten</option>
          {Object.entries(EMAIL_KIND_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={inputCls}>
          <option value="">Alle statussen</option>
          {Object.entries(EMAIL_STATUS_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
        <select value={origin} onChange={(e) => setOrigin(e.target.value)} className={inputCls}>
          <option value="">Alle herkomsten</option>
          {Object.entries(EMAIL_ORIGIN_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v.label}
            </option>
          ))}
        </select>
        <label className="flex items-center gap-1.5 text-xs text-gray-500">
          Van
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className={inputCls} />
        </label>
        <label className="flex items-center gap-1.5 text-xs text-gray-500">
          Tot
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className={inputCls} />
        </label>
        {hasFilters ? (
          <button
            type="button"
            onClick={() => {
              setSearch("");
              setAudience("");
              setStatus("");
              setKind("");
              setOrigin("");
              setFrom("");
              setTo("");
            }}
            className="text-xs font-medium text-gray-500 hover:text-gray-900"
          >
            Filters wissen
          </button>
        ) : null}
      </div>

      <EmailLogList filters={filters} limit={50} onOpen={setOpenId} />

      <EmailPreviewModal
        isOpen={!!openId}
        emailLogId={openId}
        onClose={() => setOpenId(null)}
      />
    </div>
  );
};

export default AdminVerstuurdeMailsPage;
